module.exports = __webpack_public_path__ + "static/media/list-of-goods.bb85f218.svg";